import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Home", -1)
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Clique")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Reset")

import { ref } from 'vue'
type Coiso = Array<number | string>

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const a: Coiso = [0, 1, 2, 3, 4, 5]
const b: Coiso = [0, 2, 1, 5, 6, 7]
const c = ref<Coiso>(['?', '?', '?', '?', '?', '?'])
const d = ref<Coiso[]>()
const handleClick = () => {
  for (let i = 0; i < a.length; i++) {
    if (a[i] === b[i]) {
      c.value[i] = 1
    } else {
      if (a.includes(b[i])) {
        c.value[i] = 0
      } else {
        c.value[i] = 'x'
      }
    }
  }
}

const reset = () => {
  c.value = ['?', '?', '?', '?', '?', '?']
}

return (_ctx: any,_cache: any) => {
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_btn = _resolveComponent("app-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(a, (x) => {
        return _createVNode(_component_app_card, {
          width: "150px",
          key: `a_${x}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(x), 1)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(b, (x) => {
        return _createVNode(_component_app_card, {
          width: "150px",
          key: `b_${x}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(x), 1)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.value, (x, key) => {
        return (_openBlock(), _createBlock(_component_app_card, {
          width: "150px",
          key: `c_${key}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(x), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.value, (x, key) => {
        return (_openBlock(), _createBlock(_component_app_card, {
          width: "150px",
          key: `d_${key}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(x), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createVNode(_component_app_btn, { onClick: handleClick }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode(_component_app_btn, { onClick: reset }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    })
  ], 64))
}
}

})